module.exports = __webpack_public_path__ + "static/media/iconfont.adbda8c8.eot";